import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Group } from '@libs/src/models/group.model';
import { IAppState } from '@main-client/src/app/app.state';
import { currentGroupSource } from '@main-client/src/app/group-view/group-view.helper';

@Injectable({
  providedIn: 'root',
})
export class DevelopmentProgramsEnabledGuardService implements CanActivate {
  constructor(
    public router: Router,
    public store: Store<IAppState>,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const watcher = new ReplaySubject();
    return currentGroupSource(this.store, watcher).pipe(
      take(1),
      map((group: Group) => {
        watcher.complete();
        if (group.development_programs_enabled) {
          return true;
        }
        return this.router.createUrlTree(['/']);
      }),
    );
  }
}
